import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=31c12df8&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=31c12df8&prod&lang=scss&scoped=true"
import style1 from "./ConfirmationModal.vue?vue&type=style&index=1&id=31c12df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c12df8",
  null
  
)

export default component.exports